import { useCallback, useState } from 'react';

import type { FormInstance } from 'antd';

import type { UpdateConnectorRequest } from '@/entities/connector';

type UseTypeChangeModalParams = {
  form: FormInstance<UpdateConnectorRequest>;
  selectedType?: string;
  resetJsonBridge: () => void;
  setShowConfigJson: (show: boolean) => void;
};

export const useTypeChangeModal = ({ form, resetJsonBridge, setShowConfigJson }: UseTypeChangeModalParams) => {
  const [open, setOpen] = useState(false);
  const [pendingType, setPendingType] = useState<string | null>(null);

  const handleConfirm = useCallback(() => {
    if (pendingType) {
      form.setFieldValue('type', pendingType);
      form.setFieldsValue({ config: {} });
      resetJsonBridge();
      setShowConfigJson(false);
    }
    setPendingType(null);
    setOpen(false);
  }, [pendingType, form, resetJsonBridge, setShowConfigJson]);

  const handleCancel = useCallback(() => {
    setPendingType(null);
    setOpen(false);
  }, []);

  return { open, handleConfirm, handleCancel };
};
